import { NavLink } from "react-router-dom";

const TABS = [
  { to: "/rfidTransfert", icon: "fas fa-exchange-alt", label: "Transfert" },
  { to: "/rfidInventaire", icon: "fas fa-clipboard-check", label: "Inventaire" },
  { to: "/rfidAssociation", icon: "fas fa-tags", label: "Étiquettes" },
  { to: "/rfidConfiguration", icon: "fas fa-cog", label: "Configuration" },
];

const RfidNav = () => (
  <ul className="nav nav-pills mb-3">
    {TABS.map((tab) => (
      <li className="nav-item mr-1 mb-1" key={tab.to}>
        <NavLink
          to={tab.to}
          className="nav-link"
          style={({ isActive }) =>
            isActive
              ? { backgroundColor: "#343a40", color: "#fff" }
              : { color: "#343a40", border: "1px solid #dee2e6" }
          }
        >
          <i className={`${tab.icon} mr-1`}></i>
          {tab.label}
        </NavLink>
      </li>
    ))}
  </ul>
);

export default RfidNav;
